import React from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { AGENDA_CATEGORIES, type PresetChip, type PresetCategory, formatTime12 } from './constants';

interface AddBlockPickerProps {
  dayNumber: number;
  startTime: string;
  onPick: (category: PresetCategory, chip: PresetChip) => void;
  onClose: () => void;
}

export function AddBlockPicker({ dayNumber, startTime, onPick, onClose }: AddBlockPickerProps) {
  return (
    <Modal
      isOpen
      onClose={onClose}
      size="md"
      title="Add agenda item"
      description={`Day ${dayNumber} · ${formatTime12(startTime)} — pick an item (you can rename it after).`}
    >
      <div className="max-h-[60vh] overflow-y-auto -mx-1 px-1">
        {AGENDA_CATEGORIES.map((category) => (
          <div key={category.key} className="mb-4 last:mb-0">
            <div className="flex items-center gap-1.5 mb-1.5">
              <span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: category.color }} />
              <span className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
                {category.label}
              </span>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {category.chips.map((chip) => (
                <button
                  key={chip.name}
                  type="button"
                  onClick={() => onPick(category, chip)}
                  className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-foreground border border-border hover:bg-muted transition-colors"
                >
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: category.color }} />
                  {chip.name}
                  <span className="text-[10px] text-muted-foreground">{chip.duration}m</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
}
